<div class="overlay" id="overlay"></div>
<section
  class="light-bg container border-clr"  
>
  <div class="p-3 flex justify-content-between">
    <span class="fs-20 fw-600 mt-1">Order Request</span>
    <span
      class="border-round-lg border-clr cp-8 border-1 cursor-pointer"
      (click)="close()"
      pTooltip="Close"
      tooltipPosition="bottom"
    >
      <i class="pi pi-times flex justify-content-center"></i>
    </span>
  </div>
  <div class="border-bottom-dashed border-size border-clr"></div>
  <div class="list cp-8 colHeight">
    @for (item of pendingOrderList; track $index;) {
    <div
      class="card light-bg radius-8 border-clr border-solid border-1 m-1 mt-2"
    >
      <header>
        <div class="flex justify-content-start cp-12">
          <div>
            <span class="fw-600">{{ item?.customer_name }} </span> Order Punched
            From
            <span class="fw-600">{{ item?.resource_name }}</span>
          </div>
        </div>
        <div class="border-bottom-dashed border-size border-clr"></div>
      </header>
      <div class="body">
        <div class="item cp-12">
          <!--Card For Mobile and Websites -->
          @if (item?.order_resource == 2 || item?.order_resource == 3) {
          <div class="flex justify-content-between fw-600 fs-13">
            <div># {{ item.dailyorder_id }}</div>
            <div>
              {{ item?.order_type }} @if(item?.table_no && item?.order_type ==
              "Dine in"){• {{ item?.table_no }}}
            </div>
          </div>
          <div class="flex justify-content-between fw-400 fs-14 mt-1">
            <div>{{ convertToLocalTimeZone(item?.order_date, true) }}</div>
            <div>{{ convertToLocalTimeZone(item?.order_date, false) }}</div>
          </div>
          <div class="mt-2">
            <div class="fw-600 fs-13">{{ " " }}</div>
            <div class="mt-1 fw-400 fs-14">
              {{ item?.address }}
            </div>
          </div>
          <!-- Card For POS , Tab , App  -->
          }@else{
          <div class="flex justify-content-between fw-600 fs-13">
            <span># {{ item.dailyorder_id }}</span>
            <span>
              {{ item?.order_type }} @if(item?.table_no){• {{ item?.table_no }}}
            </span>
          </div>
          <div class="flex justify-content-between fw-400 fs-14 mt-1">
            <div>{{ convertToLocalTimeZone(item?.order_date, true) }}</div>
            <div>{{ convertToLocalTimeZone(item?.order_date, false) }}</div>
          </div>
          }
        </div>

        @if (false) {
        <div class="border-bottom-dashed border-size border-clr"></div>
        <div class="cp-12">
          <div class="fs-12 fw-500 natural2-text">Invoice Type to Print</div>
          <div class="flex justify-content-between mt-2 gap-2">
            <div
              class="flex align-items-center border-1 border-clr radius-6 cpl-12 py-2 pr-3 w-full flex justify-content-between cursor-pointer"
            >
              <div>
                <div>Kitchen</div>
              </div>
              <div (click)="checkInvoice(item, { id: 1, name: 'Kitchen' })">
                <input
                  type="checkbox"
                  [id]="item.id"
                  [checked]="
                    checkIfInvoiceSelected(
                      item,
                      { id: 1, name: 'Kitchen' },
                      kitchen.id
                    )
                  "
                  class="mt-1 cursor-pointer"
                  #kitchen
                />
              </div>
            </div>

            <div
              class="flex align-items-center align-items-center border-1 border-clr radius-6 cpl-12 py-2 pr-3 w-full justify-content-between cursor-pointer"
            >
              <div class="flex align-items-center gap-2">
                <div>Customer</div>
              </div>
              <div (click)="checkInvoice(item, { id: 4, name: 'Customer' })">
                <input
                  type="checkbox"
                  [id]="item.id"
                  [checked]="checkIfInvoiceSelected(item, { id: 4, name: 'Customer', },customer.id)"
                  class="mt-2 cursor-pointer"
                  #customer
                />
              </div>
            </div>

            <div
              class="flex align-items-center align-items-center border-1 border-clr radius-6 cpl-12 py-2 pr-3 w-full flex justify-content-between cursor-pointer"
            >
              <div>
                <div>Prevision</div>
              </div>
              <div (click)="checkInvoice(item, { id: 2, name: 'Prevision' })">
                <input
                  type="checkbox"
                  [id]="item.id"
                  [checked]="
                    checkIfInvoiceSelected(
                      item,
                      { id: 2, name: 'Prevision' },
                      provision.id
                    )
                  "
                  class="mt-2 cursor-pointer"
                  #provision
                />
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      <footer>
        <div
          class="flex justify-content-between cp-12 lightPrimary-bg border-round-bottom"
        >
          <button
            pButton
            (click)="changeOrderStatusAPI(item, 8, false)"
            [disabled]="
              item?.order_resource === 5 ? 'pointer-events-none opacity-30' : ''
            "
            [loading]="loadingItemId === item.id && rejectStatus"
            class="flex justify-content-center rejectBtn-bg danger-text radius-8 cpy-8 cpx-24"
          >
            <div class="fw-500 fs-14">Reject</div>
          </button>

          <button
            pButton
            (click)="changeOrderStatusAPI(item, 3, false)"
            [loading]="loadingItemId === item.id && acceptStatus"
            class="flex justify-content-center light-bg dark-text primary-border radius-8 cpy-8 cpx-24 cursor-pointer"
          >
            <div class="fw-500 fs-14">Accept</div>
          </button>

          <button
            pButton
            (click)="changeOrderStatusAPI(item, 3, true)"
            [loading]="loadingItemId === item.id && acceptAndPrint"
            class="flex justify-content-center primary-btn primary-border radius-8 cpy-8 cpx-24 cursor-pointer"
          >
            <div class="fw-500 fs-14">Accept & Print</div>
          </button>
        </div>
      </footer>
    </div>

    } @if (loader) {
    <div class="Skeleton-Container">
      <!-- Skeleton Loader Start-->
      <div
        class="card light-bg radius-8 border-clr border-solid border-1 m-1 mt-2"
      >
        <header>
          <div class="cp-12">
            <p-skeleton width="13rem" height="22px" styleClass="mb-2" />
          </div>
          <div class="border-bottom-dashed border-size border-clr"></div>
        </header>
        <div class="body">
          <div class="item cp-12">
            <div>
              <p-skeleton width="25rem" />
            </div>
            <div class="mt-3">
              <p-skeleton width="25rem" />
            </div>
          </div>
          <div class="border-bottom-dashed border-size border-clr"></div>
          <div class="cp-12">
            <div class="fs-12 fw-500 natural2-text">
              <p-skeleton width="10rem" height="12px" />
            </div>
            <div class="flex justify-content-between mt-3 gap-2">
              <p-skeleton width="8rem" height="41px" borderRadius="6px" />
              <p-skeleton width="8rem" height="41px" borderRadius="6px" />
              <p-skeleton width="8rem" height="41px" borderRadius="6px" />
            </div>
          </div>
        </div>
        <footer>
          <div
            class="flex justify-content-between cp-12 lightPrimary-bg border-round-bottom"
          >
            <p-skeleton width="72px" height="2rem" borderRadius="8px" />
            <p-skeleton width="72px" height="2rem" borderRadius="8px" />
          </div>
        </footer>
      </div>
      <div
        class="card light-bg radius-8 border-clr border-solid border-1 m-1 mt-2"
      >
        <header>
          <div class="cp-12">
            <p-skeleton width="13rem" height="22px" styleClass="mb-2" />
          </div>
          <div class="border-bottom-dashed border-size border-clr"></div>
        </header>
        <div class="body">
          <div class="item cp-12">
            <div>
              <p-skeleton width="25rem" />
            </div>
            <div class="mt-3">
              <p-skeleton width="25rem" />
            </div>
          </div>
          <div class="border-bottom-dashed border-size border-clr"></div>
          <div class="cp-12">
            <div class="fs-12 fw-500 natural2-text">
              <p-skeleton width="10rem" height="12px" />
            </div>
            <div class="flex justify-content-between mt-3 gap-2">
              <p-skeleton width="8rem" height="41px" borderRadius="6px" />
              <p-skeleton width="8rem" height="41px" borderRadius="6px" />
              <p-skeleton width="8rem" height="41px" borderRadius="6px" />
            </div>
          </div>
        </div>
        <footer>
          <div
            class="flex justify-content-between cp-12 lightPrimary-bg border-round-bottom"
          >
            <p-skeleton width="72px" height="2rem" borderRadius="8px" />
            <p-skeleton width="72px" height="2rem" borderRadius="8px" />
          </div>
        </footer>
      </div>
      <!-- Skeleton Loader End -->
    </div>
    }
  </div>
</section>

@if(showPrintPage){
<app-invoices
  [show]="showPrintPage"
  [placeOrderObjDetail]="singleOrderDetail"
  [updateInvoiceType]="selectedInvoice"
></app-invoices>
}
